import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Team", path: "/team" }, 
    { name: "Insights", path: "/insights" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-md bg-[#0B3D91]/90 shadow-lg"
          : "bg-[#0B3D91]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex justify-between items-center">

        {/* Logo */}
        <div className="text-2xl font-bold tracking-wide text-white">
          <Link to="/">GATI @ CO.ADVOCATES</Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`relative group font-medium transition duration-300 hover:text-gray-200 ${
                location.pathname === link.path
                  ? "text-gray-200"
                  : "text-white"
              }`}
            >
              {link.name}

              {/* underline effect */}
              <span className="absolute left-0 -bottom-1 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}

          {/* CTA Button */}
          <Link
            to="/contact"
            className="bg-white text-[#0B3D91] px-5 py-2 rounded-lg font-semibold hover:bg-gray-200 transition duration-300"
          >
            Book Consultation
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-white text-2xl"
          >
            {isOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden px-6 pb-4 space-y-2 bg-[#0B3D91]">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              onClick={() => setIsOpen(false)}
              className="block py-2 text-white hover:text-gray-200 transition"
            >
              {link.name}
            </Link>
          ))}

          <Link
            to="/contact"
            className="block w-full bg-white text-[#0B3D91] px-5 py-2 rounded-lg font-semibold mt-2"
          >
            Book Consultation
          </Link>
        </div>
      )}
    </nav>
  );
}

export default Navbar;